<div class="overlay-heading">{{ heading }}</div>
<div class="overlay-info">{{ message }}</div>
<div class="btn-no-sec btn btn-primary" (click)="close()"><span class="btn-no">go back</span></div>
